(ns rothko.form2.select.multi-select.component
  (:require [medley.core :refer [find-first]]
            [reagent.core :as r]
            [rothko.component.core :refer [defcomp]]
            [rothko.component.on-click-out :as on-click-out]
            [rothko.dom.event :as dom-event]
            [rothko.form2.component :as form]
            [rothko.form2.label.component :as label]
            [rothko.form2.select.core :as select]
            [rothko.form2.validation-message.component :as validation-message]))

(defn field-value
  [selected]
  (let [field-value (mapv :value selected)]
    (when (not (empty? field-value))
      field-value)))

(defn pill-close-on-click-handler
  [{:keys [::form/set-value!] :as field-props} !state index option]
  (let [{:keys [selected]}
        (swap! !state
               (fn [{:keys [highlighted selected] :as state}]
                 (assoc state
                        :selected (into (subvec selected 0 index)
                                        (subvec selected (inc index)))
                        :highlighted (disj highlighted option))))]
    (set-value! (field-value selected))))

(defn pill
  [field-props !state index {:keys [representation tooltip] :as option}]
  (let [pill-close-on-click (dom-event/dom-event
                             (partial pill-close-on-click-handler field-props !state index option))]
    [:li.multi-select__pill (when tooltip {:title tooltip}) representation
     [:span.multi-select__pill-close-icon
      {:on-click pill-close-on-click}
      "✕"]]))

(defn pills
  [field-props !state]
  (let [pill (partial pill field-props !state)
        {:keys [selected]} @!state]
    (into [:ul.multi-select__pills]
          (map-indexed pill)
          selected)))

(defn select-input
  [!state field-props]
  (let [on-blur (partial select/blur-handler field-props)
        on-change (dom-event/dom-event (partial select/input-change-handler !state field-props))
        on-focus (partial select/input-on-focus-handler !state field-props)]
    (fn input-inner
      [_ {:keys [appearance ::form/disabled? ::form/placeholder] :as field-props}]
      (let [{:keys [input selected]} @!state]
        [:div.multi-select__input-container
         [pills field-props !state]
         [:input.multi-select__input
          {:autoComplete :off
           :class (conj appearance :select)
           :disabled disabled?
           :on-blur on-blur
           :on-change on-change
           :on-focus on-focus
           :placeholder placeholder
           :type :text
           :value input}]]))))

(defn option-toggle
  [{:keys [options selected highlighted] :as state}
   {:keys [representation value] :as option}]
  (let [present? (contains? highlighted option)
        highlighted (if present?
                      (disj highlighted option)
                      (conj highlighted option))
        selected (if present?
                   (let [index (.indexOf selected option)]
                     (into (subvec selected 0 index)
                           (subvec selected (inc index))))
                   ((fnil conj []) selected option))]
    (assoc state
           :selected selected
           :highlighted highlighted)))

(defn option-component
  [!state
   {:keys [::form/set-value!] :as field-props}
   {:keys [representation tooltip] :as option}]
  (let [highlighted? (contains? (:highlighted @!state) option)]
    [:div.multi-select__option-container
     [:div.multi-select__option
      {:class (when highlighted? [:multi-select__option--selected])
       ;; `on-mouse-down` is used as `on-click` is too late in the event handling cycle, in
       ;; particular it fires after the event used for the on-click-out component
       :on-mouse-down
       (fn [_]
         (let [{:keys [selected]} (swap! !state option-toggle option)]
           (set-value! (field-value selected))))}
      [:span (when tooltip {:title tooltip}) representation]]]))

(defn field-init
  [!state field-value options]
  (let [field-value (map
                     (fn [value]
                       (find-first #(= value (:value %)) options))
                     field-value)]
    (swap! !state (fn [state]
                    (assoc state
                           :selected (vec field-value)
                           :highlighted (set field-value))))))

(defcomp field
  [{:keys [::form/set-value-cleanly!
           ::form/value
           ::select/options]
    :as field-props}]
  (let [value (vec value)
        options (vec options)
        !state (r/atom
                {:input ""
                 :options options
                 :selected []
                 :highlighted #{}
                 :show-options? false
                 :visible-options options})
        option-component (partial option-component !state field-props)
        on-click-out (partial select/close-options-handler !state)]
    (when value (field-init !state value options))
    (on-click-out/with-on-click-out
      {:on-click-out on-click-out}
      (fn multi-select-inner
        [{:keys [appearance ref]
          :as field-props}]
        (let [{:keys [show-options? visible-options]} @!state]
          [:div.multi-select__container
           {:class appearance}
           [label/component field-props]
           [:div.multi-select {:class appearance
                               :ref ref}
            [select-input !state field-props]
            (when (and show-options?
                       (seq visible-options))
              (into [:div.multi-select__options]
                    (map option-component visible-options)))
            [validation-message/component field-props]]])))))
